module.exports = __webpack_public_path__ + "img/racetrack-flamingoPark-sand.db18d30b.svg";